import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "./ResizableTable.css";
import { Spinner } from "react-bootstrap";

const ResizableTable = ({
  columns,
  data,
  loading,
  enableFilters = true,
  selection,
  onSelectionChange,
  page = { first: 0 },
  onPage,
  rows = 10,
  totalRecords,
  onFilter,
}) => {
  return (
    <div className="resizable-table-container">
      <div className="table-scroll-x">
        {loading ? (
          <div className="flex justify-center items-center h-64">
            <Spinner animation="grow" size="sm" variant="primary" />
            <Spinner animation="grow" size="sm" variant="primary" />
            <Spinner animation="grow" size="sm" variant="primary" />
          </div>
        ) : (
          <DataTable
            value={data}
            loading={loading}
            loadingIcon={
              <div className="flex justify-center items-center h-32">
                <Spinner animation="grow" size="sm" variant="primary" />
                <Spinner animation="grow" size="sm" variant="primary" />
                <Spinner animation="grow" size="sm" variant="primary" />
              </div>
            }
            paginator
            rows={rows}
            first={page.first}
            totalRecords={totalRecords}
            onPage={onPage}
            selection={selection}
            onSelectionChange={onSelectionChange}
            onFilter={onFilter}
            selectionMode="checkbox"
            resizableColumns
            columnResizeMode="fit"
            filterDisplay="row"
            className="resizable-table"
            dataKey="id"
            emptyMessage={
              <div className="flex justify-center items-center h-32 w-full text-gray-500 text-lg">
                There are no records to display
              </div>
            }>
            <Column
              selectionMode="multiple"
              headerStyle={{ width: "3em" }}
              style={{ minWidth: "40px" }}
            />
            {columns.map((col) => (
              <Column
                key={col.field}
                field={col.field}
                header={col.header}
                sortable={col.sortable !== false}
                filter={enableFilters && col.filter !== false}
                style={{
                  minWidth: col.minWidth || "80px",
                  maxWidth: col.maxWidth || "1000px",
                }}
                body={col.body}
                headerStyle={col.headerStyle}
                bodyStyle={col.bodyStyle}
              />
            ))}
          </DataTable>
        )}
      </div>
    </div>
  );
};

export default ResizableTable;
